/* ============================================================
   SHINE & STYLE — shopping aids
   Size guide dialog and the delivery-date estimate.

   Both are honest about what they know. The estimate is computed
   from working days, not invented, and it re-computes when the
   shopper changes country in the header.
   ============================================================ */
(function () {
  'use strict';

  /* ---------------------------------------------------------
     Size guide
     A real <dialog>, so Escape, the backdrop and focus handling
     come from the browser rather than being re-implemented.
     --------------------------------------------------------- */
  var guide = document.querySelector('[data-size-guide]');

  if (guide) {
    var openers = document.querySelectorAll('[data-size-guide-open]');

    Array.prototype.forEach.call(openers, function (btn) {
      btn.addEventListener('click', function () {
        if (typeof guide.showModal === 'function') guide.showModal();
        else guide.setAttribute('open', '');       // very old browsers
      });
    });

    Array.prototype.forEach.call(
      guide.querySelectorAll('[data-size-guide-close]'),
      function (btn) {
        btn.addEventListener('click', function () {
          if (typeof guide.close === 'function') guide.close();
          else guide.removeAttribute('open');
        });
      }
    );

    // Clicking the backdrop closes it. A click on the dialog itself
    // reports the dialog as the target; the backdrop does not.
    guide.addEventListener('click', function (e) {
      if (e.target === guide && typeof guide.close === 'function') guide.close();
    });

    // Tabs between the clothing and shoe tables.
    var tabs = guide.querySelectorAll('[data-size-tab]');
    Array.prototype.forEach.call(tabs, function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-size-tab');
        Array.prototype.forEach.call(tabs, function (t) {
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });
        Array.prototype.forEach.call(
          guide.querySelectorAll('[data-size-panel]'),
          function (p) { p.hidden = p.getAttribute('data-size-panel') !== key; }
        );
      });
    });
  }

  /* ---------------------------------------------------------
     Delivery estimate
     Working days only, so a Friday order does not promise Saturday.
     Lebanon 2-3 days, Saudi 3-5, per the shipping policy.
     --------------------------------------------------------- */
  // Delivery window and the local non-working day, which is not the
  // same across these markets: Lebanon rests on Sunday, the Gulf and
  // Egypt on Friday. Getting that wrong shifts every quoted date.
  var WINDOWS = {
    'Lebanon':      { days: [2, 3], off: 0 },   // Sunday
    'Saudi Arabia': { days: [3, 5], off: 5 },   // Friday
    'UAE':          { days: [4, 6], off: 5 },
    'Egypt':        { days: [4, 7], off: 5 }
  };

  function addWorkingDays(from, days, off) {
    var d = new Date(from.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== off) added++;
    }
    return d;
  }

  function paint(country) {
    var slots = document.querySelectorAll('[data-delivery-estimate]');
    if (!slots.length) return;

    var win = WINDOWS[country] || WINDOWS.Lebanon;
    var now = new Date();
    var from = addWorkingDays(now, win.days[0], win.off);
    var to = addWorkingDays(now, win.days[1], win.off);

    var lang = document.documentElement.lang === 'ar' ? 'ar' : 'en-GB';
    var opts = { weekday: 'short', day: 'numeric', month: 'short' };
    var text;

    try {
      text = from.toLocaleDateString(lang, opts) + ' – ' + to.toLocaleDateString(lang, opts);
    } catch (e) {
      text = 'in ' + win.days[0] + '-' + win.days[1] + ' days';
    }

    Array.prototype.forEach.call(slots, function (el) {
      var target = el.querySelector('[data-delivery-dates]') || el;
      target.textContent = text;
      var where = el.querySelector('[data-delivery-country]');
      if (where) where.textContent = country;
    });
  }

  var current = 'Lebanon';
  var label = document.querySelector('[data-region-label]');
  if (label && WINDOWS[label.textContent.trim()]) current = label.textContent.trim();
  paint(current);

  // Follow the header's country picker.
  Array.prototype.forEach.call(document.querySelectorAll('[data-country]'), function (opt) {
    opt.addEventListener('click', function () {
      paint(opt.getAttribute('data-country'));
    });
  });

  /* ---------------------------------------------------------
     Low-stock note
     Driven by how many variants Shopify reports as available, which
     is real. Deliberately NOT a unit count - the export carries no
     inventory quantity, so "only 2 left" would be invented.
     --------------------------------------------------------- */
  Array.prototype.forEach.call(document.querySelectorAll('[data-sizes-left]'), function (el) {
    var n = parseInt(el.getAttribute('data-sizes-left'), 10);
    if (isNaN(n) || n === 0 || n > 3) el.hidden = true;
  });
})();
